// extracted by mini-css-extract-plugin
export var alt = "InterestLocation-module--alt--bdeeb";
export var container = "InterestLocation-module--container--4b9dc";
export var desktopOnly = "InterestLocation-module--desktopOnly--eee2d";
export var interestTitle = "InterestLocation-module--interestTitle--22c0b";
export var main = "InterestLocation-module--main--6b0cf";
export var mobileOnly = "InterestLocation-module--mobileOnly--1e1e4";
export var textLeft = "InterestLocation-module--textLeft--7d426";
export var visuallyHidden = "InterestLocation-module--visuallyHidden--25d54";